export default __webpack_public_path__ + "static/media/966.3f844867.png";